import React, { useEffect, useState } from 'react'
import TestimonialBg from "../../../../assets/images/testimonial-bg.jpg"
import User1 from "../../../../assets/images/testimonial-1.jpg"
import User2 from "../../../../assets/images/testimonial-2.jpg"

import Slider from 'react-slick'
import { axiosInstance, config } from '../../config'

const ClientReviews = () => {


    const [Loading, setLoading] = useState(false);
    const [Reviews, setReviews] = useState([]);

    useEffect(() => {
        getReviews()
    }, [])

    function getReviews() {
        setLoading(true)
        axiosInstance.get(`/get-reviews`)
            .then(res => {
                setReviews(res?.data?.reviews?.filter(item => Number(item.status) === 0).reverse())
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }


    // Never show more slots than there are reviews, so one review can't appear
    // twice on screen. With 2-3 reviews the list is repeated once so the slider
    // still has something to scroll to.
    const count = Reviews.length;
    const slotsFor = (slots) => Math.max(1, Math.min(slots, count));
    const slides = count > 1 && count <= 3 ? [...Reviews, ...Reviews] : Reviews;
    const canMove = count > 1;

    const settings = {
        dots: false,
        fade: false,
        infinite: canMove,
        speed: 800,
        autoplaySpeed: 3500,
        pauseOnHover: true,
        slidesToShow: slotsFor(3),
        slidesToScroll: 1,
        waitForAnimate: false,
        arrows: false,
        autoplay: canMove,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: slotsFor(2),
                    slidesToScroll: slotsFor(2),
                    infinite: canMove,
                    autoplay: canMove,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: slotsFor(2),
                    slidesToScroll: slotsFor(2),
                    infinite: canMove,
                    autoplay: canMove,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: canMove,
                    autoplay: canMove
                }
            }
        ]
    };


    return (
        <div>
            <section className="testimonial-section">
                <div className="bg-layer" style={{ backgroundImage: `url(${TestimonialBg})` }}></div>
                <div className="auto-container">
                    <div className="row clearfix">

                        <div className="col-lg-12 col-md-12 col-sm-12 testimonial-column">
                            <div className="testimonial-content">
                                <div className="sec-title light text-center">
                                    <h2 className='mb-4 '>What our customers Say!</h2>
                                </div>
                                <div >
                                    {/* key remounts the slider once reviews load so autoplay starts */}
                                    <Slider key={slides.length} {...settings} >
                                        {slides.length > 0 && slides.map((item, i) => (
                                            <div className="testimonial-block px-2" key={`${item.id}-${i}`}>
                                                <div className="testimonil-block-one">
                                                    <div className="inner-box">
                                                        <div className="border-box"></div>
                                                        <div className="bg-shape"></div>
                                                        <ul className="rating clearfix">
                                                            {Array(5)
                                                                .fill(0)
                                                                .map((_, index) => (
                                                                    <li key={index}>
                                                                        {index < item.rating ? (
                                                                            <i className="bi bi-star-fill"></i> // Filled star
                                                                        ) : (
                                                                            <i className="bi bi-star"></i> // Empty star
                                                                        )}
                                                                    </li>
                                                                ))}
                                                            {/* <li><i className="bi bi-star-fill"></i></li>
                                                            <li><i className="bi bi-star-fill"></i></li>
                                                            <li><i className="bi bi-star-fill"></i></li>
                                                            <li><i className="bi bi-star-fill"></i></li>
                                                            <li><i className="bi bi-star-fill"></i></li> */}
                                                        </ul>
                                                        <h4>{item?.title}</h4>
                                                        <p>{item.description}</p>
                                                        <div className="author-box">
                                                            <figure className="author-thumb"><img
                                                                src={item?.profile_photo_url || (item?.user?.image ? `${config.imageUrl}${item?.user?.image}` : User1)}
                                                                alt={item?.name || item?.user?.name || ""}
                                                                referrerPolicy="no-referrer"
                                                                onError={(e) => { e.target.onerror = null; e.target.src = User1; }}
                                                            /></figure>
                                                            <h4>{item?.user?.name || item?.name}</h4>
                                                            {/* <h6>California</h6> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                        {/* <div className="testimonial-block px-2">
                                            <div className="testimonil-block-one">
                                                <div className="inner-box">
                                                    <div className="border-box"></div>
                                                    <div className="bg-shape"></div>
                                                    <ul className="rating clearfix">
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                    </ul>
                                                    <h4>Great Experience with <br />udrive Team.</h4>
                                                    <p>I could not imagine a driving school look like udrive. It is state of art facility with rich contents and outstanding trainers. It was fun learning &amp; I enjoyed the whole experience.</p>
                                                    <div className="author-box">
                                                        <figure className="author-thumb"><img src={User2} alt="" /></figure>
                                                        <h4>Mia Isabella</h4>
                                                        <h6>Newyork</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="testimonial-block px-2">
                                            <div className="testimonil-block-one">
                                                <div className="inner-box">
                                                    <div className="border-box"></div>
                                                    <div className="bg-shape"></div>
                                                    <ul className="rating clearfix">
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                    </ul>
                                                    <h4>Great Experience with <br />udrive Team.</h4>
                                                    <p>I could not imagine a driving school look like udrive. It is state of art facility with rich contents and outstanding trainers. It was fun learning &amp; I enjoyed the whole experience.</p>
                                                    <div className="author-box">
                                                        <figure className="author-thumb"><img src={User2} alt="" /></figure>
                                                        <h4>Mia Isabella</h4>
                                                        <h6>Newyork</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default ClientReviews
